export default "__VITE_ASSET__BOBVIPui__"